import Http from '@/services/http';
import RegistrationDataService from '@/domain/services/installation/assetInfo/registrationData';
import GeneralDataService from '@/domain/services/installation/assetInfo/generalData';
import CoolingStagesService from '@/domain/services/installation/assetInfo/coolingStages';
import { buildReadingsFromCards } from './cmaCardsAdapter';

const urls = {
  getCards: assetId => `/supervisao/${assetId}/cards`,
  getAlarmDetails: 'alarme/detalhes',
};

const ACTIVE_ALARM_STATUS = ['AlarmeAtuadoENaoReconhecido', 'AlarmeAtuadoEReconhecido'];

export default {
  getActiveAlarms(assetId, installationId) {
    const http = new Http();
    return http.post(urls.getAlarmDetails, {
      ativosIds: [assetId],
      instalacaoId: installationId,
      statusAlarme: ACTIVE_ALARM_STATUS,
    }).then(({ data }) => data || [])
      .catch(() => []);
  },
  // `previousReadings` (a leitura anterior desse MESMO ativo, ou `null` na
  // 1ª leitura/troca de ativo — ver CmaDashboard.vue loadReadings) só serve
  // de fallback contra uma falha pontual de leitura de um módulo (ver
  // cmaCardsAdapter.js, withStaleFallback) — nunca é enviado ao backend.
  getReadings(assetId, installationId, previousReadings = null) {
    const http = new Http();
    return Promise.all([
      http.get(urls.getCards(assetId)).then(({ data }) => data),
      this.getActiveAlarms(assetId, installationId),
    ]).then(([cards, alarms]) => buildReadingsFromCards(cards, alarms, previousReadings));
  },
  getAssetInfo(assetId) {
    return Promise.all([
      RegistrationDataService.getRegistrationAssetData(assetId).catch(() => null),
      GeneralDataService.getGeneralTransformerData(assetId).catch(() => null),
      CoolingStagesService.getCoolingStages(assetId).catch(() => null),
    ]).then(([registrationData, transformerData, coolingStagesData]) => ({
      registrationData, transformerData, coolingStagesData,
    }));
  },
};
